import React, { useState, useEffect } from "react";
import Layout from "containers/Layout";
import "react-dropdown/style.css";

import { Headersub } from "../../GenericComponent/HeaderSub/headersub";
import { TableDanhSach } from "./TableDanhSach";
import { SearchBarDesktop } from "./SearchBar/SearchBarDesktop";
import { SearchBarMobile } from "./SearchBar/SearchBarMobile";
import StoreApi from "service/phanQuyenApi";
import LayoutV2 from "containers/LayoutV2";

export const DuNoNhanVay = () => {
  const initPhanQuyen = {
    dunonhanvay: true,
  };
  const [phanQuyen, setPhanQuyen] = useState(initPhanQuyen);

  const LoadPhanQuyen = () => {
    StoreApi.phanQuyenDuNoNhanVay().then((response) => {
      if (response.status == "200") {
        setPhanQuyen({
          ...phanQuyen,
          dunonhanvay: response.data.dunonhanvay,
        });
      }
    });
  };

  useEffect(() => {
    LoadPhanQuyen();
  }, []);
  return (
    <LayoutV2>
      {phanQuyen.dunonhanvay && (
        <div id="form-repeater">
          <div className="sticky-moman-bh">
            <div className="col-12">
              <div className="camdo-home">
                <div className="breadcrumb-new">
                  <div className="row">
                    <div className="col-sm-12 col-md-12 title-cd">
                      <div className="media-home align-center-home">
                        <div className="row header">
                          <img
                            src="/app-assets/images/icon-hop-dong-cho-duyet.png"
                            alt="logo"
                          />
                          <h1 className="text-info-home">Dư nợ nhận vay</h1>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card border-light mb-1 hidden-mobile-main show-table-main card-v2">
                  <div className="card-body card-body-v2">
                    <SearchBarDesktop />
                    <SearchBarMobile />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <TableDanhSach />
        </div>
      )}
      {!phanQuyen.dunonhanvay && (
        <div id="form-repeater">
          <div className="sticky-moman-bh">
            <div className="col-12">
              <div className="camdo-home">
                <div className="breadcrumb-new">
                  <div className="row">
                    <div className="col-sm-12 col-md-12 title-cd">
                      <div className="media-home align-center-home">
                        <div className="row header">
                          <img
                            src="/app-assets/images/icon-hop-dong-cho-duyet.png"
                            alt="logo"
                          />
                          <h1 className="text-info-home">Dư nợ nhận vay</h1>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <span
            style={{
              textAlign: "center",
              color: "red",
              display: "flex",
              justifyContent: "center",
            }}
          >
            Bạn không có quyền truy cập chức năng này.
          </span>
        </div>
      )}
    </LayoutV2>
  );
};
